//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import CreateIcon from "../../Icons/CreateIcon";
import { createTagSchema, ITagSchema } from "../../utils/validationSchema";
import TagForm from "./TagForm";

export interface ICreateTagsData {
  name: string;
  description: string;
  previewImage: File | null;
}

const CreateTag = (props: any) => {
  const { isLoading, handleCreate } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<ITagSchema>({
    defaultValues: async () => ({
      name: "",
      preview_image: null,
      description: "",
    }),
    resolver: yupResolver(createTagSchema),
  });

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Create Tag</span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <TagForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
      </FormLayout>
    </div>
  );
};

export default CreateTag;
